import request from "@/utils/request";
import { SharedCallbacks } from "@/utils/shared-resources";

/**
 * Set the currently used device to a device selected by user and that has location in backend
 */

export interface IDeviceLocation {
  id: number;
  uuid: string;
  name: string;
  status: string;
  stats: any;
  hardwareUid: string;
}
export async function setDeviceLocation(payload: {
  stats: any;
  hardwareUid: string;
  fiskalyCashRegisterId: string;
  name: string;
  status: number;
  groupId: number;
  deviceId: number;
}): Promise<IDeviceLocation> {
  const {
    stats,
    hardwareUid,
    fiskalyCashRegisterId,
    name,
    status,
    deviceId,
    groupId,
  } = payload;
  const params: { [posConfigId: string]: number | undefined } = {};
  const getPOSConfigId = SharedCallbacks.getPOSConfigId;
  if (getPOSConfigId) {
    params.posConfigId = getPOSConfigId();
  }
  const response = await request({
    url: `/group/${groupId}/device/${deviceId}`,
    method: "patch",
    data: {
      stats,
      hardwareUid: hardwareUid,
      fiskalyCashRegisterId,
      name,
      status,
    },
    params,
  });

  return response.data.data;
}
